import { ModerationActionList } from '@/moderation-actions/ModerationActionList'

export function ModerationActions() {
  return <ModerationActionList />
}
